export default {
    CurrentWeek:1,
    CurrentMonth:2,
    Completed:3,
    OverallSeason:4,
};


// WEBPACK FOOTER //
// ./src/containers/eventsview/constants/searchtype.js